import React from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import AppRoutes from "./routes/Routes";


const AppWrapper = () => {
  const location = useLocation();
  const hideNavbar = 
    location.pathname === "/transaction" ||
    location.pathname === "/confirmation";

  return (
    <>
      {!hideNavbar && <Navbar />}
      <AppRoutes />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
};

export default App;

// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <AppRoutes />
//     </Router>
//   );
// }

// export default App;
